import { memo, type FC } from 'react';

import type { FieldRenderProps } from '@/js/libs/final-form/index.ts';

import Label from '../Label/index.tsx';
import { Textarea } from './index.tsx';

interface TextareaFieldProps extends FieldRenderProps<string | undefined, HTMLElement> {
  label?: string;
  labelTooltip?: string;
  required?: boolean;
  rows?: number;
}

export const TextareaField: FC<TextareaFieldProps> = memo(function TextareaField({
  input,
  meta,
  label,
  labelTooltip,
  required,
  disabled,
  rows,
  ...props
}) {
  return (
    <>
      {label ? (
        <Label disabled={disabled} required={required} tooltip={labelTooltip}>
          {label}
        </Label>
      ) : null}
      <Textarea {...input} error={meta.touched && (meta.error || meta.submitError)} disabled={disabled} rows={rows} {...props} />
    </>
  );
});
